module.exports = __webpack_public_path__ + "static/media/invrelations.d210c745.jpg";